import React from 'react';
import {connect} from 'react-redux';
import util from 'Utils/commonUtil';
import Dialog from 'Components/common/Dialog';
// Components
import Header from 'Components/common/Header';
import SearchInput from 'Components/common/SearchInput';
import ScrollWrapper from 'Components/common/ScrollWrapper';
import ProxyDeliveryPackageOnTheGoItem from './ProxyDeliveryPackageOnTheGoItem';
import BackTop from 'Components/common/BackTop';
import {
    PROXY_DELIVERY_ORDER_PACKAGE_SORT,
    PROXY_DELIVERY_ORDER_TAB_FLAG,
} from 'Utils/constant';

// Actions
import {
    getProxyDeliveryOrderList,
    getProxyDeliveryPackageOrderList,
    updateProxyDeliveryOrderListPageNum,
    updateProxyDeliveryPackageSort,
    updateProxyDeliveryOrderSearchFileld,
    setProxyDeliveryOrderSource,
    updateProxyDeliveryOrderTabActive,
    updateProxyDeliveryOrderListData,
    updateProxyDeliveryPackageListData,
    updateViewReceivePackageData,
    getSysDict,
} from 'Actions/proxyDelivery';
import {T} from 'Actions/translate';
import ProxyDeliveryReject from 'Components/host/proxyDeliveryManagement/ProxyDeliveryReject';
import {loadLanguage} from 'Utils/jwtUtil';

class ProxyDeliveryOrderList extends React.Component {
    pager = {
        page: 0,
        length: 10,
        total: 0,
        pageTotal: 9999999999999999999999999,
    };
    packagePager = {
        page: 0,
        length: 10,
        total: 0,
        pageTotal: 9999999999999999999999999,
    };

    state = {
        searchValue: '',
        tabList: [
            {
                index: 0,
                text: T('fone_order_on_the_parcel'),
                tabFlag: PROXY_DELIVERY_ORDER_TAB_FLAG.In_TRANSIT_PACKAGE,
            },
            {
                index: 1,
                text: T('proxy_delivery_received_awaiting_status'),
                tabFlag: PROXY_DELIVERY_ORDER_TAB_FLAG.WAIT_FOR_RECEIVING,
            },
            {
                index: 2,
                text: T('off_the_stocks'),
                tabFlag: PROXY_DELIVERY_ORDER_TAB_FLAG.COMPLETED_PACKAGE,
            },
        ],
        tabActive:
            typeof this.props.tabActive === 'number' ? this.props.tabActive : 0,
        listLoaded: true,
        currentShipmentSort: PROXY_DELIVERY_ORDER_PACKAGE_SORT.ASC_SORT,
        openRejectDialog: false,
        uploadFileBtnIsLoading: false,
        signItemData: {},
    };

    componentDidMount() {
        this.initializeListData();

        let dictType = 'PROXY_DELIVERY_SHIPMENT_STATUS';
        this.props.getSysDict(dictType);
        // const locationState =
        //     this.props.history && this.props.history.location
        //         ? this.props.history.location.state
        //         : undefined;
        // if (locationState && locationState.highlightItemId) {
        //     setTimeout(this.scrollToHighlightedItem, 0);
        // }
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.tabActive !== this.props.tabActive &&
            this.props.tabActive !== this.state.tabActive
        ) {
            this.setState({tabActive: this.props.tabActive});
        }
    }

    initializeListData = () => {
        const {tabList} = this.state;
        const {tabActive} = this.props;
        const activeTab = tabList[tabActive] || tabList[0];

        if (!activeTab) return;

        if (
            activeTab.tabFlag ===
                PROXY_DELIVERY_ORDER_TAB_FLAG.In_TRANSIT_PACKAGE ||
            activeTab.tabFlag ===
                PROXY_DELIVERY_ORDER_TAB_FLAG.WAIT_FOR_RECEIVING ||
            activeTab.tabFlag ===
                PROXY_DELIVERY_ORDER_TAB_FLAG.COMPLETED_PACKAGE
        ) {
            if (
                !this.props.fromProxyDeliveryOrderDetails ||
                this.props.currentProxyDeliveryOrderPageNum === 0
            ) {
                this.props.updateProxyDeliveryOrderListPageNum({$set: 0});
                this.props.updateProxyDeliveryOrderSearchFileld({
                    queryKey: '',
                });
                this.packagePager.page = 0;
                this.getProxyDeliveryPackageOrderList();
            } else {
                this.props.setProxyDeliveryOrderSource({$set: false});
                this.packagePager.page =
                    this.props.currentProxyDeliveryOrderPageNum;
                this.setState({
                    currentShipmentSort: this.props.proxyDeliveryPackageSort,
                });
            }
        } else {
            this.pager.page = this.props.currentProxyDeliveryOrderPageNum;
        }
    };

    handleChangeTab(item) {
        this.props.updateProxyDeliveryOrderTabActive({$set: item.index});
        this.setState({tabActive: item.index, listLoaded: false}, () => {
            const {tabList, tabActive} = this.state;
            const activeTab = tabList[tabActive];
            if (!activeTab) {
                this.setState({listLoaded: true});
                return;
            }

            this.props.updateProxyDeliveryPackageListData([]);
            this.packagePager.page = 0;
            this.packagePager.total = 0;
            this.packagePager.pageTotal = 9999999999999999999999999;
            this.getProxyDeliveryPackageOrderList();
        });
    }

    getProxyDeliveryOrderList = () => {
        const {tabList} = this.state;
        const {tabActive} = this.props;

        this.props.setProxyDeliveryOrderSource({$set: false});
        if (this.pager.page >= this.pager.pageTotal) return;

        this.setState({listLoaded: false});

        this.props
            .getProxyDeliveryOrderList({
                pageNum: this.pager.page + 1,
                pageSize: this.pager.length,
                tabFlag: tabList[tabActive].tabFlag,
                queryKey: this.props.queryKey,
            })
            .then((res) => {
                this.pager.page = res.pageNum;
                this.pager.total = res.total;
                this.pager.pageTotal = res.pageTotal;
                this.setState({listLoaded: true});
            });
    };

    getTabStatus = () => {
        const {tabList} = this.state;
        const activeIndex =
            typeof this.state.tabActive === 'number'
                ? this.state.tabActive
                : typeof this.props.tabActive === 'number'
                ? this.props.tabActive
                : 0;
        const activeTab = tabList[activeIndex];

        if (!activeTab) {
            return '';
        }

        switch (activeTab.tabFlag) {
            case PROXY_DELIVERY_ORDER_TAB_FLAG.In_TRANSIT_PACKAGE:
                return 'IN_TRANSIT';
            case PROXY_DELIVERY_ORDER_TAB_FLAG.WAIT_FOR_RECEIVING:
                return 'WAIT_CUSTOMER_RECEIPT';
            case PROXY_DELIVERY_ORDER_TAB_FLAG.COMPLETED_PACKAGE:
                return 'COMPLETED';
            default:
                return '';
        }
    };

    getIsAscSort = () => {
        const {tabList, currentShipmentSort} = this.state;
        const activeIndex =
            typeof this.state.tabActive === 'number'
                ? this.state.tabActive
                : typeof this.props.tabActive === 'number'
                ? this.props.tabActive
                : 0;
        const activeTab = tabList[activeIndex];

        if (
            activeTab &&
            activeTab.tabFlag ===
                PROXY_DELIVERY_ORDER_TAB_FLAG.In_TRANSIT_PACKAGE
        ) {
            return (
                currentShipmentSort ===
                PROXY_DELIVERY_ORDER_PACKAGE_SORT.ASC_SORT
            );
        }

        return undefined;
    };

    getProxyDeliveryPackageOrderList = (useCurrentPageNum = false) => {
        this.props.setProxyDeliveryOrderSource({$set: false});

        if (this.packagePager.page >= this.packagePager.pageTotal) return;

        this.setState({listLoaded: false}, () => {
            const requestParams = {
                pageNum: useCurrentPageNum
                    ? this.packagePager.page
                    : this.packagePager.page + 1,
                pageSize: this.packagePager.length,
                queryKey: this.props.queryKey,
                status: this.getTabStatus(),
            };
            const isAsc = this.getIsAscSort();

            if (typeof isAsc !== 'undefined') {
                requestParams.isAsc = isAsc;
            }

            this.props
                .getProxyDeliveryPackageOrderList(requestParams)
                .then((res) => {
                    this.packagePager.page = res.pageNum;
                    this.packagePager.total = res.total;
                    this.packagePager.pageTotal = res.pageTotal;
                    this.setState({listLoaded: true});
                });
        });
    };

    chooseItem = (item) => {
        this.props.updateViewReceivePackageData({});

        const {tabList} = this.state;
        const {tabActive, statusOptions} = this.props;

        this.props.updateProxyDeliveryOrderListPageNum({
            $set: this.packagePager.page,
        });
        this.props.setProxyDeliveryOrderSource({$set: true});

        this.props.updateProxyDeliveryPackageSort({
            $set: this.state.currentShipmentSort,
        });
        const activeTabFlag = tabList[tabActive].tabFlag;

        this.props.history.push(`/proxyDeliveryForPackageReceive/`, {
            id: item.id,
            orderNumber: item.orderNumber,
            shipmentNumber: item.shipmentNumber,
            f1Number: item.orderNumber,
            tabFlag: activeTabFlag,
            tabActive: tabActive,
            statusOptions: statusOptions,
        });
    };
    goBack = () => {
        this.props.updateProxyDeliveryOrderSearchFileld({
            queryKey: '',
        });
        this.props.history.push('/userCenter');
    };

    search = () => {
        this.props.updateProxyDeliveryPackageListData([]);
        this.props.updateProxyDeliveryOrderListPageNum({$set: 0});
        this.packagePager.page = 0;
        this.packagePager.total = 0;
        this.packagePager.pageTotal = 9999999999999999999999999;
        this.getProxyDeliveryPackageOrderList();
    };

    onChange = (title, value) => {
        this.props.updateProxyDeliveryOrderSearchFileld({
            [title]: value,
        });
    };

    proxyDeliveryPackageSort = (sortType) => {
        this.setState(
            {
                currentShipmentSort:
                    sortType === PROXY_DELIVERY_ORDER_PACKAGE_SORT.ASC_SORT
                        ? PROXY_DELIVERY_ORDER_PACKAGE_SORT.DESC_SORT
                        : PROXY_DELIVERY_ORDER_PACKAGE_SORT.ASC_SORT,
            },
            () => {
                this.props.updateProxyDeliveryPackageListData([]);
                this.props.updateProxyDeliveryOrderListPageNum({$set: 0});
                this.packagePager.page = 0;
                this.packagePager.total = 0;
                this.packagePager.pageTotal = 9999999999999999999999999;
                this.getProxyDeliveryPackageOrderList();
            },
        );
    };

    render() {
        const {
            tabList,
            listLoaded,
            currentShipmentSort,
            openRejectDialog,
            uploadFileBtnIsLoading,
            signItemData,
        } = this.state;
        const {tabActive, proxyDeliveryPackageOrderList} = this.props;

        return (
            <div className="proxy-delivery-order-list-container">
                <Header
                    hasUserCenter={true}
                    hasArrowBackIos={true}
                    backEvent={this.goBack}>
                    <div className="proxy-delivery-order-list-header">
                        <div className="proxy-delivery-order-list-header-title">
                            <h3 className="header-title">
                                {T(
                                    'user_center_proxy_delivery_order_management',
                                )}
                            </h3>
                        </div>

                        <SearchInput
                            title="queryKey"
                            value={this.props.queryKey}
                            placeholder={T(
                                'proxy_delivery_order_list_search_placeholder',
                            )}
                            search={this.search}
                            onChange={this.onChange}></SearchInput>
                    </div>
                    <div className="tab-header">
                        {tabList.map((item, index) => {
                            return (
                                <div
                                    key={item.index}
                                    id={'f1OrderTab' + item.index}>
                                    <button
                                        key={item.index}
                                        id={'f1Order' + item.index}
                                        className={util.getClassName({
                                            'tab-item': true,
                                            active: index === tabActive,
                                        })}
                                        onClick={() => {
                                            this.handleChangeTab(item);
                                        }}>
                                        {item.text}
                                    </button>

                                    {item.index === 0 && tabActive === 0 && (
                                        <div className="proxy-delivery-package-sort">
                                            {currentShipmentSort ===
                                            PROXY_DELIVERY_ORDER_PACKAGE_SORT.ASC_SORT ? (
                                                <img
                                                    src={
                                                        new URL(
                                                            'Images/sortup.svg',
                                                            import.meta.url,
                                                        ).href
                                                    }
                                                    alt=""
                                                    onClick={() =>
                                                        this.proxyDeliveryPackageSort(
                                                            PROXY_DELIVERY_ORDER_PACKAGE_SORT.ASC_SORT,
                                                        )
                                                    }
                                                />
                                            ) : (
                                                <img
                                                    src={
                                                        new URL(
                                                            'Images/sortdown.svg',
                                                            import.meta.url,
                                                        ).href
                                                    }
                                                    alt=""
                                                    onClick={() =>
                                                        this.proxyDeliveryPackageSort(
                                                            PROXY_DELIVERY_ORDER_PACKAGE_SORT.DESC_SORT,
                                                        )
                                                    }
                                                />
                                            )}
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </Header>
                <ScrollWrapper
                    listLoaded={listLoaded}
                    showAbyss={
                        this.packagePager.page >= this.packagePager.pageTotal
                    }
                    showLoadingMore={!listLoaded}
                    getMoreData={this.getProxyDeliveryPackageOrderList}>
                    <ul className="proxy-delivery-order-list">
                        {proxyDeliveryPackageOrderList &&
                            proxyDeliveryPackageOrderList.map((item, index) => (
                                <li
                                    key={index}
                                    id={`order-${item.id}`}
                                    className="proxy-delivery-order-item">
                                    <ProxyDeliveryPackageOnTheGoItem
                                        item={item}
                                        statusOptions={this.props.statusOptions}
                                        tabActive={tabActive}
                                        chooseItem={() => this.chooseItem(item)}
                                    />
                                </li>
                            ))}
                    </ul>
                    <BackTop />
                </ScrollWrapper>
                <Dialog
                    opened={openRejectDialog}
                    dialogDidClose={() =>
                        this.setState({openRejectDialog: false})
                    }
                    options={{bgClickClose: !uploadFileBtnIsLoading}}>
                    <ProxyDeliveryReject
                        onClose={() =>
                            this.dialogDidClose(
                                'uploadReceiveImageDialogOpened',
                            )
                        }
                    />
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {proxyDelivery} = state;
    return {
        proxyDeliveryPackageSort: proxyDelivery.proxyDeliveryPackageSort,
        proxyDeliveryOrderList: proxyDelivery.proxyDeliveryOrderList,
        proxyDeliveryOrderListLoad: proxyDelivery.proxyDeliveryOrderListLoad,
        proxyDeliveryPackageOrderList:
            proxyDelivery.proxyDeliveryPackageOrderList,
        proxyDeliveryPackageOrderListLoad:
            proxyDelivery.proxyDeliveryPackageOrderListLoad,
        currentProxyDeliveryOrderPageNum:
            proxyDelivery.currentProxyDeliveryOrderPageNum,
        fromProxyDeliveryOrderDetails:
            proxyDelivery.fromProxyDeliveryOrderDetails,
        tabActive: proxyDelivery.tabActive,
        queryKey: proxyDelivery.proxyDeliveryOrderSearchfields.queryKey,
        statusOptions: proxyDelivery.statusOptions,
    };
};

const mapDispatchToProps = {
    getProxyDeliveryOrderList,
    getProxyDeliveryPackageOrderList,
    updateProxyDeliveryOrderListPageNum,
    updateProxyDeliveryPackageSort,
    updateProxyDeliveryOrderSearchFileld,
    updateProxyDeliveryOrderListData,
    updateProxyDeliveryPackageListData,
    updateProxyDeliveryOrderTabActive,
    setProxyDeliveryOrderSource,
    updateViewReceivePackageData,
    getSysDict,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ProxyDeliveryOrderList);
